<template>
  <div>
    <navMenu />
    
    <hero :heroTitle="$t('footer.t&c')" :heroSubtitle="$t('t&cPage.subtitle')"  />

    <section class="jsk-block pt-0">
      <div class="container">
        <div class="row">
          <div class="col-12 col-md-12">
            <h4 class="text-uppercase">{{ $t('t&cPage.zeroTitle') }}</h4>
            <p>{{ $t('t&cPage.zeroPOne') }}</p>
            <p>
              {{ $t('t&cPage.zeroPTwo') }}
            </p>
            <p>
              {{ $t('t&cPage.zeroPThree') }}
            </p>
            <p>
              {{ $t('t&cPage.zeroPFour') }}
            </p>
            <h4 class="mt-5 text-uppercase">{{ $t('t&cPage.zeroZeroTitle') }}</h4>
            <p>
              {{ $t('t&cPage.zeroZeroDescr') }}
            </p>
            <h4 class="mt-5 text-uppercase">{{ $t('t&cPage.oneTitle') }}</h4>
            <p>
              {{ $t('t&cPage.oneP') }}
            </p>
            <h4 class="mt-5 text-uppercase">{{ $t('t&cPage.twoTitle') }}</h4>
            <p>
              {{ $t('t&cPage.twoPOne') }}
            </p>
            <p>
               {{ $t('t&cPage.twoPTwo') }}
            </p>
            <h4 class="mt-5 text-uppercase">{{ $t('t&cPage.threeTitle') }}</h4>
            <p>
              {{ $t('t&cPage.threePOne') }}
            </p>
            <p>
               {{ $t('t&cPage.threePTwo') }}
            </p>
            <h4 class="mt-5 text-uppercase">{{ $t('t&cPage.fourTitle') }}</h4>
            <p>
              {{ $t('t&cPage.fourP') }}
            </p>
            <h4 class="mt-5 text-uppercase">{{ $t('t&cPage.fiveTitle') }}</h4>
            <p>
              {{ $t('t&cPage.fiveP') }}
            </p>

            <h4 class="mt-5 text-uppercase">{{ $t('t&cPage.sixTitle') }}</h4>
            <p>
              {{ $t('t&cPage.sixPOne') }}
            </p>
            <p>
              {{ $t('t&cPage.sixPTwo') }}
            </p>
            <p>
              {{ $t('t&cPage.sixPThree') }}
            </p>
            <p>
              {{ $t('t&cPage.sixPFour') }}
            </p>
            
            <h4 class="mt-5 text-uppercase">{{ $t('t&cPage.sixOneTitle') }}</h4>
            <p>
              {{ $t('t&cPage.sixOneP') }}
            <ul>
              <li> {{ $t('t&cPage.sixOneFonts') }} <a href="https://fonts.google.com/" target="_blank" class="link-underlined">Google Fonts</a> Luckiest Guy + Montserrat</li>
              <li> {{ $t('t&cPage.sixOneIcons') }} <a href="https://fontawesome.com/?from=io" target="_blank" class="link-underlined">Font Awesome</a> si <a href="https://www.flaticon.com/" target="_blank" class="link-underlined">Flaticon</a></li>
              <li> {{ $t('t&cPage.sixOneGraphics') }} <a href="https://www.freepik.com/" target="_blank" class="link-underlined">Freepik</a> </li>
            </ul>
          </p>

          <h4 class="mt-5 text-uppercase">{{ $t('t&cPage.sevenTitle') }}</h4>
          <p>
            {{ $t('t&cPage.sevenP') }}
          </p>
          <ul>
            <li>{{ $t('t&cPage.sevenItems[0]') }}</li>
            <li>{{ $t('t&cPage.sevenItems[1]') }}</li>
            <li>{{ $t('t&cPage.sevenItems[2]') }}</li>
            <li>{{ $t('t&cPage.sevenItems[3]') }}</li>
            <li>{{ $t('t&cPage.sevenItems[4]') }}</li>
            <li>{{ $t('t&cPage.sevenItems[5]') }}</li>
            <li>{{ $t('t&cPage.sevenItems[6]') }}</li>
            <li>{{ $t('t&cPage.sevenItems[7]') }}</li>
            <li>{{ $t('t&cPage.sevenItems[8]') }}</li>
            <li>{{ $t('t&cPage.sevenItems[9]') }}</li>
          </ul>

          <h4 class="mt-5 text-uppercase">{{ $t('t&cPage.eightTitle') }}</h4>
          <p>
            {{ $t('t&cPage.eightP') }}
          </p>
          
          <h4 class="mt-5 text-uppercase">{{ $t('t&cPage.nineTitle') }}</h4>
          <p>
            {{ $t('t&cPage.nineP') }}
          </p>
          
          <h4 class="mt-5 text-uppercase">{{ $t('t&cPage.tenTitle') }}</h4>
          <p>
            {{ $t('t&cPage.tenPOne') }}
          </p>
          <p>
            {{ $t('t&cPage.tenPTwo') }}
          </p>
          <p>
            {{ $t('t&cPage.tenPThree') }}
          </p>
          <p>
            {{ $t('t&cPage.tenPFour') }}
          </p>
          
          <h4 class="mt-5 text-uppercase">{{ $t('t&cPage.elevenTitle') }}</h4>
          <p>
            {{ $t('t&cPage.elevenP') }}
          </p>
          
          <h4 class="mt-5 text-uppercase">{{ $t('t&cPage.twelveTitle') }}</h4>
          <p>
            {{ $t('t&cPage.twelvePOne') }}
          </p>
          <p>
             {{ $t('t&cPage.twelvePTwo') }}
          </p>
          
          <h4 class="mt-5 text-uppercase">{{ $t('t&cPage.thirteenTitle') }}</h4>
          <p>
            {{ $t('t&cPage.thirteenP') }}
          </p>
          
          <h4 class="mt-5 text-uppercase"></h4>
          <p>
            {{ $t('t&cPage.fourteenP') }}
          </p>

          <h4 class="mt-5 text-uppercase">{{ $t('t&cPage.fifteenTitle') }}</h4>
          <p> {{ $t('t&cPage.fifteenTOne') }}
            <router-link to="/privacy-policy" 
              >{{ $t("footer.pp") }}</router-link
            > 
            {{ $t('t&cPage.fifteenTTwo') }}
          </p>

          <h4 class="mt-5 text-uppercase">{{ $t('t&cPage.sixteenTitle') }}</h4>
          <p>
            {{ $t('t&cPage.sixteenP') }}
          </p>

          <h4 class="mt-5 text-uppercase">{{ $t('t&cPage.seventeenTitle') }}</h4>
          <p>
            {{ $t('t&cPage.seventeenP') }}
          </p>

          <h4 class="mt-5 text-uppercase">{{ $t('t&cPage.eighteenTitle') }}</h4>
          <p>
            {{ $t('t&cPage.eighteenP') }}
          </p>

          <h4 class="mt-5 text-uppercase">{{ $t('t&cPage.nineteenTitle') }}</h4>
          <p>
            {{ $t('t&cPage.nineteenP') }}
          </p>

          <h4 class="mt-5 text-uppercase">{{ $t('t&cPage.twentyTitle') }}</h4>
          <p>
            {{ $t('t&cPage.twentyP') }}
          </p>

          <h4 class="mt-5 text-uppercase">{{ $t('t&cPage.twentyoneTitle') }}</h4>
          <p>
            {{ $t('t&cPage.twentyoneP') }}
          </p>
        </div>
        </div>
      </div>
    </section>


    <footerJSK />
  </div>
</template>

<script>
import footerJSK from "./../components/footer.vue";
import navMenu from "./../components/navMenu.vue";
import hero from "./../components/hero.vue";

export default {
  name: "TermsAndConditions",
  components: {
    navMenu,
    hero,
    footerJSK
  },
  mounted () {
    window.scrollTo(0, 0)
  }
};
</script>
